import styled from "styled-components";

export const WorkerAvatarStyles = styled.div`
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.accent[100]};
  border: 2px solid ${({ theme }) => theme.colors.semantic.container.white};
  overflow: hidden;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .profileImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .initials {
    font-size: ${({ $size }) => `${Math.round($size * 0.4)}px`};
    font-weight: 600;
    line-height: 1;
    color: ${({ theme }) => theme.colors.accent[700]};
    user-select: none;
  }
`;
